<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom">
    </iframe>
  </div>
</template>

<script>
  import request from "../../api/nesting";

  export default {
    name: "dangerousChemicals",
    data() {
      return {
        getPageUrl: ''
      }
    },
    created() {
      let configUrlType = ''
      switch (this.$route.path) {
        // 危害信息维护
        case '/hazardInformation':
          configUrlType = '41'
          break
        // 危害信息查询
        case '/hazardInformationQuery':
          configUrlType = '42'
          break
        // 危害信息变更
        case '/hazardInformationBg':
          configUrlType = '43'
          break
        // 危害信息变更查询
        case '/hazardInfoChangeQuery':
          configUrlType = '44'
          break
        default:
          return
      }
      request.getCoalSupplySynergyUrl({
        configUrlType
      }).then(res => {
        if (res.status) {
          this.getPageUrl = res.data.configUrl
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  /** iframe样式 */
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>